import React, {ReactNode, ReactNodeArray} from 'react';
import EpiComponent from '@episerver/spa-core/EpiComponent';
import UpdateSubscriberNameBlockData from '../../../Models/Content/UpdateSubscriberNameBlockData';
import UpdateSubscriberName from './UpdateSubscriberName';

export default class UpdateSubscriberNameBlock extends EpiComponent<UpdateSubscriberNameBlockData> {
  constructor(props) {
    super(props);
  }

  public render(): ReactNode | ReactNodeArray | null {
    return <UpdateSubscriberName context={this.getContext()} iContent={this.props.data} />;
  }
}
